export const PRECISION = 500;

export function roundToPrecision(value: number) {
  return Math.round(value / PRECISION) * PRECISION;
}

export function clampInRange(value: number, min: number, max: number) {
  return Math.min(Math.max(value, min), max);
}
